module.exports = __webpack_public_path__ + "static/media/promo-6.46ff037e.png";